module.exports = __webpack_public_path__ + "img/image_09.45ab552c.png";